export interface PurchaseOrderSalesAllocation {
  id: string;
  purchaseOrderLineId: string;
  salesOrderLineId: string;
  salesOrderAndLineNo: string;
  customerKey: string;
  customerName: string;
  productKey: string;
  productDescription: string;
  productType: string;
  balance: number;
  allocated: number;
  totalAllocated: number;
  freeStock: number;
  qtyRequired: number;
  selected: boolean;
  canDelete: boolean;
  deliveryDate: Date;
  nearestEighth: boolean;
  deliveryAddressName: string;
  deliveryAddress: string;
}
